module.exports = __webpack_public_path__ + "img/icon2.df00199e.png";